<div class="mb-2">
  <label *ngIf="!labelHide && labelValue.length > 0" class="form-label">
    {{ labelValue }}
    <sup *ngIf="isRequired">*</sup>
    <!-- Custom Toggle Button -->
  </label>

  <div class="editor-wrapper">
    <!-- Quill Editor -->
    <quill-editor #quillEditor theme="snow" [modules]="editorModules" (onEditorCreated)="onEditorCreated($event)"
      (onContentChanged)="onEditorChanged($event)" [formControl]="$any(control)" [styles]="{ height: '300px' }"
      [readOnly]="disabled || showHtml" [id]="id" [placeholder]="placeholder" [ngClass]="{
        inputClassPrimary: inputType === 'primary',
        inputClassPrimaryWithoutBorder: inputType === 'primaryWithoutBorder',
        inputClassSecondary: inputType === 'secondary',
        inputClassSecondaryWithoutBorder: inputType === 'secondaryWithoutBorder',
        inputClassWarning: inputType === 'warning',
        inputClassWarningWithoutBorder: inputType === 'warningWithoutBorder',
        inputClassSuccess: inputType === 'success',
        inputClassSuccessWithoutBorder: inputType === 'successWithoutBorder',
        inputClassError: inputType === 'error',
        inputClassErrorWithoutBorder: inputType === 'errorWithoutBorder',
        inputClassDisabled: disabled
      }">
    </quill-editor>
  </div>

  <label *ngIf="errorMessage.length > 0" class="error-label">
    {{ errorMessage }}
  </label>
</div>